import { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import '@/App.css';

import { TopNav } from '@/components/TopNav';
import { Footer, CopyrightBar } from '@/components/Footer';
import { BottomNav } from '@/components/BottomNav';

import Home from '@/pages/Home';
import Services from '@/pages/Services';
import Solutions from '@/pages/Solutions';
import CaseStudies from '@/pages/CaseStudies';
import Industries from '@/pages/Industries';
import Insights from '@/pages/Insights';
import About from '@/pages/About';
import Contact from '@/pages/Contact';
import { Privacy, Terms } from '@/pages/Legal';
import { CustomCursor } from '@/components/CustomCursor';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' in window ? 'instant' : 'auto' });
  }, [pathname]);
  return null;
}

export default function App() {
  return (
    <div className="App min-h-screen bg-white">
      <BrowserRouter>
        <CustomCursor />
        <ScrollToTop />
        <TopNav />
        <main data-testid="main-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/solutions" element={<Solutions />} />
            <Route path="/case-studies" element={<CaseStudies />} />
            <Route path="/industries" element={<Industries />} />
            <Route path="/insights" element={<Insights />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="*" element={<Home />} />
          </Routes>
        </main>
        <Footer />
        <CopyrightBar />
        <BottomNav />
      </BrowserRouter>
    </div>
  );
}
